export default __webpack_public_path__ + "static/gatsby-astronaut-b8fa5292fbd59c2db05281ba94ae9428.png";